import { Svg } from '../../../components/Svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ContentRemixIcon = () => {
  return /*#__PURE__*/_jsxs(Svg, {
    $size: "32px",
    $color: "currentColor",
    $alignWithText: false,
    viewBox: "0 0 32 32",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M9.49333 28.0003C12.52 28.0003 14.9867 25.5337 14.9867 22.507C14.9867 19.4803 12.52 17.0137 9.49333 17.0137C6.46667 17.0137 4 19.4803 4 22.507C4 25.5337 6.46667 28.0003 9.49333 28.0003ZM9.49333 19.0003C11.4267 19.0003 12.9867 20.5737 12.9867 22.4937C12.9867 24.4137 11.4133 25.987 9.49333 25.987C7.57333 25.987 6 24.4137 6 22.4937C6 20.5737 7.57333 19.0003 9.49333 19.0003Z",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("path", {
      d: "M17 18V27C17 27.5467 17.4533 28 18 28H27C27.5467 28 28 27.5467 28 27V18C28 17.4533 27.5467 17 27 17H18C17.4533 17 17 17.4533 17 18ZM19 19H26V26H19V19Z",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("path", {
      d: "M11.0002 14.9999H21.3869C21.7469 14.9999 22.0802 14.8132 22.2536 14.4932C22.4269 14.1732 22.4269 13.7999 22.2536 13.4932L17.0536 4.4932C16.6936 3.87987 15.6802 3.87987 15.3202 4.4932L10.1202 13.4932C9.9469 13.7999 9.9469 14.1865 10.1202 14.4932C10.2936 14.7999 10.6269 14.9999 10.9869 14.9999H11.0002ZM16.2002 6.99987L19.6669 12.9999H12.7336L16.2002 6.99987Z",
      fill: "currentColor"
    })]
  });
};
export default ContentRemixIcon;